import type { PrinterType } from '../../services/printing.service';

/**
 * The printer each type was last sent to in THIS browser session. A dispatcher
 * printing twenty sheets picks once. Deliberately not persisted: the saved
 * preference is the default printer in user settings, this is just a memory.
 */
const memory = new Map<PrinterType, string>();

export const lastUsedPrinter = {
  get: (type: PrinterType): string | undefined => memory.get(type),
  set: (type: PrinterType, installname: string): void => { memory.set(type, installname); },
  clear: (): void => memory.clear(),
};
